import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Badge,
  Input,
  Button,
} from "reactstrap"
import ButtonSpinner from "../../components/ButtonSpinner"
// import Rating from "react-rating"
import ReactStars from "react-rating-stars-component"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import Dropzone from "react-dropzone"
import { withRouter, Link } from "react-router-dom"
import { connect, useDispatch } from "react-redux"
import Select from "react-select"
import PropTypes from "prop-types"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import Modal from "react-bootstrap/Modal"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
import * as freelancerQcAction from "../../store/ZnJlZWxhbmNlclFj/actions"
import moment from "moment"
import "./styles.scss"
import { toast, ToastContainer } from "react-toastify"
import api from "helpers/Api"

const FreelancerQc = (props) => {
  const title = "Freelancer QC"

  const { dispatch, searchBarStyle } = props

  const specificDispatch = useDispatch()
  useEffect(() => {
    dispatch(freelancerQcAction.loadRecordsMetaData())
    dispatch(freelancerQcAction.loadEmployee())
    dispatch(
      freelancerQcAction.loadFreelancerList({
        page: 1,
        limit: 50,
        isManageEc: true,
      })
    )
  }, [])

  // Data table laoder
  const response = localStorage.getItem("responseTime")
  console.log(response, "response")

  const freelancerUpdate = useSelector(
    (specificstate) => specificstate.freelancerQc
  )

  const {
    recordsMetaData = {},
    employee_list = [],
    freelancer_qc_details = [],
  } = freelancerUpdate

  const [freelancerData, setFreelancerData] = useState({
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  const handleChange = (e) => {
    setFreelancerData({ ...freelancerData, [e.target.name]: e.target.value })
  }

  const sessionUpdate = useSelector((specificState) => specificState.session)

  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)
  console.log(authUser, "authUser")
  // console.log(response, "response User")
  console.log(responseLogin, "responseLogin")

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //State maintenance
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [auditAttachmentModal, setAuditAttachmentModal] = useState(false)
  const handleAttachmentModal = () => setAuditAttachmentModal(false)

  //Data table button list start
  const [statusModal, setPaymentStatusModal] = useState(false)
  const [auditModalData, setAuditModalData] = useState("")
  const handleStatusModal = () => setPaymentStatusModal(false)

  const [ratingModal, setRatingModal] = useState(false)
  //   const [auditRatingData, setAuditRatingData] = useState("")
  const handleRatingModal = () => setRatingModal(false)

  const [remarksModal, setRemarksModal] = useState(false)
  //   const [auditRemarksData, setAuditRemarksData] = useState("")
  const handleRemarksModal = () => setRemarksModal(false)

  //Attachments
  const [ticketAttachmentFiles, setTicketAttachmentFiles] = useState([])
  const [ticketAttachment, setTicketAttachment] = useState([])
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const handleTicketAttachmentFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    if (files) {
      // console.log("qqqq", e.target.files)

      var file = files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = ticketAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setTicketAttachment(teamUploadValue)
          }
        })
      }
    }
    setTicketAttachmentFiles(files)
  }

  console.log(ticketAttachment, "ticketAttachment")
  //Data table button list End

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //EMployee list

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)
  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  const [resetManager, setResetManager] = useState(false)
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSalesAgent([])
    setEvents([])
    setFreelancerData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      freelancerQcAction.loadFreelancerList({
        page: 1,
        limit: 50,
        isManageEC: true,
      })
    )
  }

  // EditableLabel
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  //Searchvalue
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")
  const [searchInput, setSearchInput] = useState("")
  const [pageCount, setPageCount] = useState("")
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : searchInput
    ? {
        isManageEC: true,
        page: pageChange ? pageCount : 1,
        limit: 50,
        searchFilter: searchInput,
      }
    : {
        isManageEC: true,
        page: pageChange ? pageCount : 1,
        limit: 50,
      }
  //filter section
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    var searchLeadNo = freelancerData && freelancerData.leadNo
    var searchFromDate =
      freelancerData && freelancerData.fromDate
        ? moment(freelancerData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      freelancerData && freelancerData.toDate
        ? moment(freelancerData.toDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    searchvalue.page = 1
    searchvalue.limit = 50
    searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    console.log(searchvalue, "searchvalue")
    setSearchValueList(searchvalue)
    specificDispatch(freelancerQcAction.loadFreelancerList(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  console.log(freelancer_qc_details, "followup audit details")

  let slNo = 0
  const followupfreelancerDataTable = !isEmpty(freelancer_qc_details)
    ? freelancer_qc_details.data.map((data, index) => {
        slNo = slNo + 1

        const leadDate = data.leadDate
          ? moment(data.leadDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []

        const eventCount =
          !isEmpty(data) && data.teamScheduleServiceDetails.length > 0
            ? data.teamScheduleServiceDetails.length
            : 0

        const colorCode =
          !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0
            ? recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === data.ecProcessStatus
              ) &&
              recordsMetaData.processStatusOptions.find(
                (_) => _.processStatusId === data.ecProcessStatus
              ).colorCode
            : ""

        console.log(colorCode, "colorCode")
        console.log(data.ecProcessStatus, "ecProcessStatus")
        return {
          _id: data._id,
          sNo: slNo,
          leadno: data.leadNo,
          routeData: data,
          branchId: data.branchId,
          branchName: data.branchName,
          groomName: data.groomName,
          brideName: data.brideName,
          clientName: !isEmpty(data.clientDetails)
            ? data.clientDetails.firstName + " " + data.clientDetails.lastName
            : "",
          companyId: data.companyId,
          companyName: data.companyName,
          leadServiceName: data.leadServiceName,
          leadSourceName: data.leadSourceName,
          leadType: data.leadType,
          salesUrge: data.salesUrge,
          colorCode: !isEmpty(colorCode) ? colorCode : "",
          overallStatus: !isEmpty(data.overAllStatus)
            ? data.overAllStatus
            : "--",
          allowOrderData: data.isAllowOrder,
          allowOrder: data.isAllowOrder === true ? "YES" : "NO",
          eventDetails: data.events,
          clientCode: !isEmpty(data.clientDetails)
            ? data.clientDetails.clientNo
            : "",
          teamScheduleCount: eventCount,
          teamScheduleDetails: data.teamScheduleServiceDetails,
          ecAssign: isEmpty(data.ecPrcessStatusName)
            ? "Unassigned"
            : "Assigned",
          assignedEcName: !isEmpty(data.leadECAssign)
            ? data.leadECAssign.assignedToName
            : "",
          leadDate: leadDate,
          clientDetails: data.clientDetails,
          ecProcessStatus: data.ecProcessStatus,
          teamScheduleId: data.teamScheduleId,
          teamScheduleServiceDetails: data.teamScheduleServiceDetails,
          ecProcessStatusName: data.ecProcessStatusName,
          ecStatus:
            data.ecProcessStatus !== "PS2" ? data.ecPrcessStatusName : "--",
          status: data.status,
          clearanceStatus: (
            <Badge
              color={data.ecProcessStatus === "PS21" ? "success" : "danger"}
              style={{ padding: "6px" }}
            >
              Clearance
            </Badge>
          ),
          //           leadStatus: data.leadStatus,
          leadStatus: (
            <Badge
              color={
                data.leadAssign.leadStatus === "PS2" ? "success" : "danger"
              }
              style={{ padding: "6px" }}
            >
              {" "}
              {!isEmpty(data) && data.leadAssign.leadStatus === "PS2"
                ? "Assigned"
                : "Unassigned"}
            </Badge>
          ),
          isAssigned: data.isAssigned,
          salesAgent: data.leadAssign,
          enquiryDate: leadDate,
          clientNo: data.clientNo,
          contact: data.contact,
          clientVisit: data.clientVisit,
          followupDate: data.followupDate,

          leadNo: data.leadNo,
          clientStatus: data.clientStatus,
          quoteStatus: data.quotationStatus === true ? "YES" : "NO",
          followupStrategy: !isEmpty(data.currentFollowupDetail)
            ? data.currentFollowupDetail.followupStrategyName
            : "--",
          visitDateTime: data.visitDateTime,
          remarks: !isEmpty(data.currentFollowupDetail)
            ? data.currentFollowupDetail.remarks
            : "--",
          budget: !isEmpty(data.currentFollowupDetail)
            ? data.currentFollowupDetail.budget
            : "--",
          clientProfile: !isEmpty(data.currentFollowupDetail)
            ? data.currentFollowupDetail.clientProfileName
            : "--",
          reason: data.reason,
          followupStatus: data.followupStatus,
          toTime: data.toTime,
          isAudit: data.isAudit,
          key: index,
        }
      })
    : []

  console.log(followupfreelancerDataTable, "followupfreelancerDataTable")

  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
    },
    {
      dataField: "leadno",
      text: "Lead No",
      sort: true,
      hidden: false,
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: leadData,
                  leadClientId: leadData,
                  mode: "EC",
                  menuName: "FreelancerReport",
                },
              }}
            >
              <span>{row.leadno}</span>
            </Link>
          </>
        )
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "156px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      sort: true,
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      hidden: false,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "126px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      sort: true,
      hidden: false,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "assignedEcName",
      text: "Ec Agent Name",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "teamScheduleCount",
      text: "No of Freelancers",
      sort: true,
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.teamScheduleCount}
            </span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "status",
      text: "Audit Status",
      sort: true,
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <Badge
              color={
                !isEmpty(row) && row.isAudit === "YES" ? "success" : "danger"
              }
              style={{ padding: "8px", fontSize: "12px" }}
            >
              {!isEmpty(row) && row.isAudit === "YES"
                ? "Completed"
                : "Not Completed"}
            </Badge>
          </>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]

  //Payment status

  //Columns section
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  //Audit section
  const statusList = [
    {
      label: "paid",
      value: "paid",
    },
    {
      label: "hold",
      value: "hold",
    },
    {
      label: "unpaid",
      value: "unpaid",
    },
  ]

  const [auditingPaymentStatus, setAuditingPaymentStatus] = useState([])
  //   const [auditingRating, setAuditingRating] = useState([])
  const [auditingRemarksData, setAuditingRemarksData] = useState({
    remarks: "",
  })

  const handleChangeRemarks = (e) => {
    setAuditingRemarksData({
      ...auditingRemarksData,
      [e.target.name]: e.target.value,
    })
  }

  //Edit Audit Status
  const editAuditPaymentStatus = (audit) => {
    console.log(audit, "audit status from edit")
    const statusValue = !isEmpty(audit) && audit ? audit : ""

    const paymentStatus = !isEmpty(statusValue)
      ? {
          label: statusValue,
          value: statusValue,
        }
      : []
    setAuditingPaymentStatus(paymentStatus)
    setPaymentStatusModal(true)
    // setAuditModalData(audit)
  }

  //Edit audit rating
  const editAuditRating = (audit) => {
    console.log(audit, "audit")
    // setAuditModalData(audit)
    setRatingModal(true)
    const rating = !isEmpty(audit) && audit ? audit : ""
    setCallOpening(rating)
  }

  // Audit Remarks submit
  const editAuditRemarks = (audit) => {
    console.log(audit, "audit")
    setRemarksModal(true)

    setAuditingRemarksData({
      remarks: audit ? audit : "",
    })
  }

  const teamScheduleId =
    !isEmpty(auditModalData) && auditModalData.teamScheduleId
      ? auditModalData.teamScheduleId
      : ""
  const serviceDetailsId =
    !isEmpty(auditModalData) && auditModalData.teamServiceDetailId
      ? auditModalData.teamServiceDetailId
      : ""
  const teamFreelanceShooterData =
    !isEmpty(auditModalData) &&
    auditModalData.teamFreelanceShooter &&
    auditModalData.teamFreelanceShooter.length > 0
      ? auditModalData.teamFreelanceShooter[0].teamScheduleFreelanceId
      : ""
  // Audit status submit
  const handleStatusSubmit = () => {
    let auditStatus = {
      teamScheduleId: teamScheduleId,
      serviceDetailsId: serviceDetailsId,
      teamFreelanceShooterId: teamFreelanceShooterData,
      auditPaymentStatus: auditingPaymentStatus.value,
    }
    console.log(auditStatus, "status from checked")
    specificDispatch(freelancerQcAction.updateAuditStatus(auditStatus))
    setTimeout(() => {
      specificDispatch(freelancerQcAction.loadFreelancerList(searchValue))
      toast.success("Audit Status Updated Successfully")
      handleStatusModal()
    }, 1000)
  }

  //Audit Rating

  //Star icons
  const ratingProps = {
    emptyIcon: <i className="far fa-star" />,
    halfIcon: <i className="fa fa-star-half-alt" />,
    filledIcon: <i className="fa fa-star" />,
  }
  //Rating Change
  const [callOpening, setCallOpening] = useState("")

  //Rating final submit
  const handleRatingSubmit = () => {
    let auditStatus = {
      teamScheduleId: teamScheduleId,
      serviceDetailsId: serviceDetailsId,
      teamFreelanceShooterId: teamFreelanceShooterData,
      auditRatings: callOpening,
    }
    specificDispatch(freelancerQcAction.updateAuditStatus(auditStatus))
    setTimeout(() => {
      specificDispatch(freelancerQcAction.loadFreelancerList(searchValue))
      toast.success("Audit Rating Updated Successfully")
      setRatingModal(false)
    }, 1000)
  }

  //Remarks final submit
  const handleRemarksSubmit = () => {
    let auditStatus = {
      teamScheduleId: teamScheduleId,
      serviceDetailsId: serviceDetailsId,
      teamFreelanceShooterId: teamFreelanceShooterData,
      auditRemarks: auditingRemarksData.remarks,
    }

    specificDispatch(freelancerQcAction.updateAuditStatus(auditStatus))
    setTimeout(() => {
      specificDispatch(freelancerQcAction.loadFreelancerList(searchValue))
      setRemarksModal(false)
      toast.success("Audit Remarks Updated Successfully")
    }, 1000)
  }

  //Pagination section start //
  //Search filter

  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      freelancerQcAction.loadFreelancerList({
        searchFilter: searchInput,
        isManageEC: true,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchFromDate =
      freelancerData && freelancerData.fromDate
        ? moment(freelancerData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      freelancerData && freelancerData.toDate
        ? moment(freelancerData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      freelancerData && freelancerData.leadNo ? freelancerData.leadNo : ""

    var searchvalue = {}
    searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_freelancer_audit_report`, searchvalue)
      .then((response) => {
        console.log(response.data, "response")

        const freelancerExportDataTable = !isEmpty(response.data)
          ? response.data.data.map((freelancerData, index) => {
              slNo = slNo + 1

              // const dateFormate =
              //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

              const leadDate = freelancerData.leadDate
                ? moment(freelancerData.leadDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                : []

              const eventCount =
                !isEmpty(freelancerData) &&
                freelancerData.teamScheduleServiceDetails.length > 0
                  ? freelancerData.teamScheduleServiceDetails.length
                  : 0

              const colorCode =
                !isEmpty(recordsMetaData) &&
                recordsMetaData.processStatusOptions &&
                recordsMetaData.processStatusOptions.length > 0
                  ? recordsMetaData.processStatusOptions.find(
                      (_) =>
                        _.processStatusId === freelancerData.ecProcessStatus
                    ) &&
                    recordsMetaData.processStatusOptions.find(
                      (_) =>
                        _.processStatusId === freelancerData.ecProcessStatus
                    ).colorCode
                  : ""

              console.log(colorCode, "colorCode")
              console.log(freelancerData.ecProcessStatus, "ecProcessStatus")
              return {
                _id: freelancerData._id,
                sNo: index + 1,
                leadNo: freelancerData.leadNo,
                routeData: freelancerData,
                branchId: freelancerData.branchId,
                branchName: freelancerData.branchName,
                groomName: freelancerData.groomName,
                brideName: freelancerData.brideName,
                clientName: !isEmpty(freelancerData.clientDetails)
                  ? freelancerData.clientDetails.firstName +
                    " " +
                    freelancerData.clientDetails.lastName
                  : "",
                companyId: freelancerData.companyId,
                companyName: freelancerData.companyName,
                leadServiceName: freelancerData.leadServiceName,
                leadSourceName: freelancerData.leadSourceName,
                leadType: freelancerData.leadType,
                salesUrge: freelancerData.salesUrge,
                colorCode: !isEmpty(colorCode) ? colorCode : "",
                overallStatus: !isEmpty(freelancerData.overAllStatus)
                  ? freelancerData.overAllStatus
                  : "--",
                allowOrderData: freelancerData.isAllowOrder,
                allowOrder: freelancerData.isAllowOrder === true ? "YES" : "NO",
                eventDetails: freelancerData.events,
                clientCode: !isEmpty(freelancerData.clientDetails)
                  ? freelancerData.clientDetails.clientNo
                  : "",
                teamScheduleCount: eventCount,
                teamScheduleDetails: freelancerData.teamScheduleServiceDetails,
                ecAssign: isEmpty(freelancerData.ecPrcessStatusName)
                  ? "Unassigned"
                  : "Assigned",
                assignedEcName: !isEmpty(freelancerData.leadECAssign)
                  ? freelancerData.leadECAssign.assignedToName
                  : "",
                leadDate: leadDate,
                ecProcessStatus: freelancerData.ecProcessStatus,
                teamScheduleId: freelancerData.teamScheduleId,
                ecProcessStatusName: freelancerData.ecPrcessStatusName,
                ecStatus:
                  freelancerData.ecProcessStatus !== "PS2"
                    ? freelancerData.ecPrcessStatusName
                    : "--",
                status:
                  !isEmpty(freelancerData) &&
                  freelancerData.isAssigned === "Yes"
                    ? "Completed"
                    : "Not Completed",
                clearanceStatus: (
                  <Badge
                    color={
                      freelancerData.ecProcessStatus === "PS21"
                        ? "success"
                        : "danger"
                    }
                    style={{ padding: "6px" }}
                  >
                    Clearance
                  </Badge>
                ),
                leadStatus: (
                  <Badge
                    color={
                      freelancerData.leadAssign.leadStatus === "PS2"
                        ? "success"
                        : "danger"
                    }
                    style={{ padding: "6px" }}
                  >
                    {" "}
                    {!isEmpty(freelancerData) &&
                    freelancerData.leadAssign.leadStatus === "PS2"
                      ? "Assigned"
                      : "Unassigned"}
                  </Badge>
                ),
                key: index,
                isAssigned: freelancerData.isAssigned,
                isAudit:
                  freelancerData.isAudit == "YES" ? "Completed" : "InCompleted",
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Lead No,Company,Branch,Client Code,Client Name,Bride Name,Groom Name, Lead Date, Ec Agent Name,No of Freelancers,Overall Status, Status",
          ]

          let usersCsv = !isEmpty(freelancerExportDataTable)
            ? freelancerExportDataTable.reduce((acc, user) => {
                const {
                  sNo,
                  leadNo,
                  companyName,
                  branchName,
                  clientCode,
                  clientName,
                  brideName,
                  groomName,
                  leadDate,
                  assignedEcName,
                  teamScheduleCount,
                  overallStatus,
                  isAudit,
                  //     ecAssign,
                  //     leadClearanceName,
                } = user
                acc.push([
                  sNo,
                  leadNo,
                  companyName,
                  branchName,
                  clientCode,
                  clientName,
                  brideName,
                  groomName,
                  leadDate,
                  assignedEcName,
                  teamScheduleCount,
                  overallStatus,
                  isAudit,
                  //     ecAssign,
                  //     leadClearanceName,
                ])

                console.log("test", acc)
                return acc
              }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "FreelancerQcReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }
  const noDataIndication = () => (
    <div className="spinner">
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  )
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                          className="d-flex flex-row"
                        >
                          <div
                            style={{
                              marginBottom: "20px",
                              marginTop: "-40px",
                              marginRight: "10px",
                            }}
                          >
                            <Button
                              className="btn btn-info"
                              onClick={() => setColumnModal(true)}
                            >
                              Edit Columns
                            </Button>
                          </div>
                          <div
                            style={{
                              float: "right",
                            }}
                          >
                            <Button
                              className="btn btn-primary"
                              onClick={exportToCsv}
                              id="download"
                              style={{
                                backgroundColor: "#e40d8c",
                                color: "white",
                                border: "none",
                                marginBottom: "20px",
                                marginTop: "-41px",
                              }}
                            >
                              Download
                            </Button>
                          </div>
                        </div>
                      </Col>

                      <Col id="my-component">
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          expandRow={expandRow}
                          noDataIndication={noDataIndication}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: freelancer_qc_details.length,
    data:
      !isEmpty(freelancer_qc_details) && freelancer_qc_details.length > 0
        ? freelancer_qc_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(freelancer_qc_details.data) &&
      freelancer_qc_details.data.length > 0
        ? freelancer_qc_details.data
        : []

    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchFromDate =
      freelancerData && freelancerData.fromDate
        ? moment(freelancerData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      freelancerData && freelancerData.toDate
        ? moment(freelancerData.toDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    searchvalue.page = page
    searchvalue.limit = 50
    searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    specificDispatch(freelancerQcAction.loadFreelancerList(searchvalue))

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 1400)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //expand row functionality from bootstrap table

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Audit Rating
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Audit Remarks
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Audit Payment Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Attachments
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.teamScheduleDetails.length > 0 ? (
              row.teamScheduleDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")

                if (
                  new Date(data.eventDate) >=
                    new Date(freelancerData.fromDate) &&
                  new Date(data.eventDate) <= new Date(freelancerData.toDate)
                ) {
                  const freelancerData =
                    !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                      ? data.teamFreelanceShooter.map((data) => data)
                      : []
                  console.log(freelancerData, "freelancerData")

                  const freelancerName =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].freelancerMainShooterName
                      : "--"
                  const auditRatings =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].auditRatings
                      : ""
                  const auditRemarks =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].auditRemarks
                      : ""
                  const auditPaymentStatus =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].auditPaymentStatus
                      : ""
                  return (
                    <tr key={data._id}>
                      <td>{!isEmpty(data.eventNo) ? data.eventNo : "--"}</td>
                      <td>
                        {!isEmpty(data.eventName) ? data.eventName : "--"}
                      </td>
                      <td>{moment(data.eventDate).format(dateFormate)}</td>
                      <td>
                        {!isEmpty(data.serviceName) ? data.serviceName : "--"}
                      </td>
                      <td>{freelancerName}</td>
                      <td>
                        {" "}
                        <button
                          onClick={() => {
                            editAuditRating(auditRatings)
                            setAuditModalData(data)
                          }}
                          className={
                            !isEmpty(auditRatings)
                              ? "approved-btn"
                              : "audit-pending-btn"
                          }
                        >
                          {!isEmpty(auditRatings) ? "Completed" : "Pending"}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            editAuditRemarks(auditRemarks)
                            setAuditModalData(data)
                          }}
                          className={
                            !isEmpty(auditRemarks)
                              ? "approved-btn"
                              : "audit-pending-btn"
                          }
                        >
                          {!isEmpty(auditRemarks) ? "Completed" : "Pending"}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            editAuditPaymentStatus(auditRemarks)
                            setAuditModalData(data)
                          }}
                          className={
                            !isEmpty(auditPaymentStatus)
                              ? "approved-btn"
                              : "audit-pending-btn"
                          }
                        >
                          {!isEmpty(auditPaymentStatus)
                            ? "Completed"
                            : "Pending"}
                        </button>
                      </td>
                      <td>
                        <div className="d-flex flex-row justify-content-between">
                          <button
                            className="btn btn-info px-3 py-1"
                            onClick={() => setAuditAttachmentModal(true)}
                          >
                            Attachment
                          </button>
                          {/* {!isEmpty(attachments) ? ( */}
                          <a
                            // onClick={() => window.open(attachments, "_blank")}
                            rel="noopener noreferrer"
                            className="mx-2 mt-2"
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#E40D8C",
                              }}
                            >
                              View
                            </span>
                          </a>
                          {/* ) : (
                            ""
                          )} */}
                        </div>
                      </td>
                    </tr>
                  )
                } else if (
                  isEmpty(freelancerData.fromDate) &&
                  isEmpty(freelancerData.toDate)
                ) {
                  const freelancerData =
                    !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                      ? data.teamFreelanceShooter.map((data) => data)
                      : ""
                  console.log(freelancerData, "freelancerData")

                  const freelancerName =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].freelancerMainShooterName
                      : "--"
                  const auditRatings =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].auditRatings
                      : ""

                  console.log(auditRatings, "auditRatings")
                  const auditRemarks =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].auditRemarks
                      : ""
                  const auditPaymentStatus =
                    !isEmpty(freelancerData) && freelancerData.length > 0
                      ? freelancerData[0].auditPaymentStatus
                      : ""

                  return (
                    <tr key={data._id}>
                      <td>{!isEmpty(data.eventNo) ? data.eventNo : "--"}</td>
                      <td>
                        {!isEmpty(data.eventName) ? data.eventName : "--"}
                      </td>
                      <td>{moment(data.eventDate).format(dateFormate)}</td>
                      <td>
                        {!isEmpty(data.serviceName) ? data.serviceName : "--"}
                      </td>
                      <td>{freelancerName}</td>
                      <td>
                        {" "}
                        <button
                          onClick={() => {
                            editAuditRating(auditRatings)
                            setAuditModalData(data)
                          }}
                          className={
                            !isEmpty(auditRatings)
                              ? "approved-btn"
                              : "audit-pending-btn"
                          }
                        >
                          {!isEmpty(auditRatings) ? "Completed" : "Pending"}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            editAuditRemarks(auditRemarks)
                            setAuditModalData(data)
                          }}
                          className={
                            !isEmpty(auditRemarks)
                              ? "approved-btn"
                              : "audit-pending-btn"
                          }
                        >
                          {!isEmpty(auditRemarks) ? "Completed" : "Pending"}
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            editAuditPaymentStatus(auditPaymentStatus)
                            setAuditModalData(data)
                          }}
                          className={
                            !isEmpty(auditPaymentStatus)
                              ? "approved-btn"
                              : "audit-pending-btn"
                          }
                        >
                          {!isEmpty(auditPaymentStatus)
                            ? "Completed"
                            : "Pending"}
                        </button>
                      </td>
                      <td>
                        <div className="d-flex flex-row">
                          <button
                            className="btn btn-info px-3 py-1"
                            onClick={() => setAuditAttachmentModal(true)}
                          >
                            Attachment
                          </button>
                          {/* {!isEmpty(attachments) ? ( */}
                          <a
                            // onClick={() => window.open(attachments, "_blank")}
                            rel="noopener noreferrer"
                            className="mx-2 mt-2"
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "#E40D8C",
                              }}
                            >
                              View
                            </span>
                          </a>
                          {/* ) : (
                            ""
                          )} */}
                        </div>
                      </td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={5}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Approvals"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={companies}
                        onChange={(e) => setCompanies(e)}
                        isMulti
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        placeholder="Select company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        isMulti
                        value={branches}
                        onChange={(e) => setBranches(e)}
                        options={branchOptions}
                        placeholder="Select branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Event"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="events"
                        value={events}
                        // isMulti
                        onChange={(e) => setEvents(e)}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        placeholder="Select event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">Ec Agent</Label>
                      <ReactSearchAutocomplete
                        name="salesAgent"
                        key={resetManager}
                        items={agentOptions}
                        value={salesAgent}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setSalesAgent(e)}
                        // onChange={(e) => setSalesAgent(e.target.value)}
                        placeholder="Enter Ec Agent"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Event From Date</Label>
                      <Input
                        type="date"
                        placeholder="YYYY-MM-DD"
                        name="fromDate"
                        value={freelancerData.fromDate}
                        max={freelancerData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Event to Date</Label>
                      <Input
                        type="date"
                        placeholder="YYYY-MM-DD"
                        name="toDate"
                        min={freelancerData.fromDate}
                        value={freelancerData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Lead No"}>
                          {"Lead No"}
                        </Label>
                      </div>
                      <Input
                        type="text"
                        name="leadNo"
                        value={freelancerData.leadNo}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Lead No"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => resetForm()}
                          className="btn btn-danger btn-label simple-form-Reset-btn"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Col className="sales-followup-card">
          <Row>
            <Col className="mt-1 mb-3">
              <Row>
                <Col md="12" lg="12" xl="12">
                  <Card>
                    <CardBody>
                      <div
                        className="d-flex flex-row"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                          <form
                            onSubmit={handleClick}
                            className="d-flex flex-row"
                          >
                            <div style={searchBarStyle || null}>
                              <Input
                                type="text"
                                name="searchInput"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                className="form-control"
                                placeholder="Search"
                                style={{ position: "relative" }}
                              />
                              <i
                                className="bx bx-search-alt"
                                style={{
                                  position: "absolute",
                                  top: "54px",
                                  left: "41px",
                                  fontSize: "13px",
                                }}
                              />
                            </div>
                            <button
                              className="btn btn-success mx-2"
                              type="submit"
                              style={{
                                background: searchFilter ? "#2ca67a" : "",
                                color: searchFilter ? "#ffffff" : "",
                              }}
                              // onClick={(e) => handleClick()}
                            >
                              <i className="fas fa-search"></i>
                            </button>
                          </form>
                        </div>
                      </div>{" "}
                      {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                      <RemotePagination
                        data={followupfreelancerDataTable}
                        page={page}
                        sizePerPage={sizePerPage}
                        totalSize={
                          !isEmpty(freelancer_qc_details)
                            ? freelancer_qc_details.totalDataCount
                            : 0
                        }
                        onTableChange={handleTableChange}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        {statusModal && (
          <Modal show={statusModal} onHide={handleStatusModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Payment Status</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                <Label>Payment Status</Label>
                <Select
                  name="auditingPaymentStatus"
                  value={auditingPaymentStatus}
                  options={statusList}
                  onChange={(e) => setAuditingPaymentStatus(e)}
                  placeholder="Select Payment Status"
                />
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleStatusModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleStatusSubmit}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {ratingModal && (
          <Modal
            show={ratingModal}
            onHide={handleRatingModal}
            scrollable={true}
            size="md"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Audit Rating</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mt-2 d-flex flex-column"
              >
                {" "}
                <Label className="audit-rating-label">1. Rating (1 -10)</Label>
                {/* {isEmpty(auditRatingData.currentFollowupDetail.auditRating) ||
                ratingCallOpening === null ? ( */}
                <ReactStars
                  count={10}
                  size={18}
                  isHalf={true}
                  a11y={true}
                  name="callOpening"
                  value={callOpening}
                  {...ratingProps}
                  activeColor="#f3d329"
                  onChange={(e) => {
                    setCallOpening(e)
                  }}
                  // classNames="rating-styles"
                />
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleRatingModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleRatingSubmit}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {columnModal && (
          <Modal size="xl" show={columnModal}>
            <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Edit Columns
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setColumnModal(false)}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <div>
                  <Input
                    type="checkbox"
                    checked={selectedColumns.length === columns.length}
                    onChange={(e) => handleSelectAllChange(e)}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                    Select All
                  </Label>
                </div>
              </Row>
              <Row>
                <Col sm="12" md="6" lg="6" className="ml-4">
                  {oddColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
                <Col sm="12" md="6" lg="6">
                  {evenColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <p
                className="text-decoration-underline text-info"
                style={{ cursor: "pointer", fontSize: "16px" }}
                onClick={handleRestoreToDefault}
              >
                Restore To Default
              </p>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setColumnModal(false)
                  setSelectedColumns(selectColumn)
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => handleSaveColumns()}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {remarksModal && (
          <Modal show={remarksModal} onHide={handleRemarksModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Audit Remarks</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                {" "}
                {/* <Label className="employee-label">Audit Status</Label> */}
                <div className="d-flex flex-column">
                  <Label style={{ marginTop: "2px", fontSize: "12px" }}>
                    Remarks
                  </Label>
                  <Input
                    type="textarea"
                    name="remarks"
                    value={auditingRemarksData.remarks}
                    onChange={(e) => handleChangeRemarks(e)}
                    placeholder="Enter the Remarks"
                    className="event-crowd-textarea"
                  />
                </div>
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-4">
                <div>
                  <h5>Remarks History</h5>
                </div>
                <Table responsive bordered striped className="mt-3">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Audit completed</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={() => setRemarksModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={() => handleRemarksSubmit()}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {auditAttachmentModal && (
          <Modal
            show={auditAttachmentModal}
            onHide={handleAttachmentModal}
            size="md"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                Attachments
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                style={{ marginTop: "20px" }}
              >
                <Row className="d-flex flex-row">
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Row>
                      <Col xl="12" lg="12" md="12" sm="12" xs="12">
                        <div className="mt-1">
                          <Dropzone
                            onDrop={(acceptedFiles) => {
                              handleTicketAttachmentFiles(acceptedFiles)
                            }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div
                                className="dropzone-img"
                                style={{ height: "90px" }}
                              >
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div
                                    className="dz-message needsclick"
                                    style={{ marginTop: "-61px" }}
                                  >
                                    <div className="mb-3">
                                      <i className="display-4 text-muted bx bxs-cloud-upload" />
                                    </div>
                                    <h4>Drop files here or click to upload.</h4>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                          {/* {simpleValidator.current.message(
                                      "ticketAttachmentFiles",
                                      ticketAttachmentFiles,
                                      "required"
                                    )} */}
                          {/* <Input name="ticketAttachment" value={ticketAttachment} /> */}
                        </div>
                      </Col>
                      <Col xl="12" lg="12" md="12" sm="12" xs="12">
                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {!isEmpty(ticketAttachmentFiles)
                            ? ticketAttachmentFiles.map((f, i) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                          >
                                            {f.name}
                                          </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                )
                              })
                            : ""}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleAttachmentModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleAttachmentModal}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {/* {remarksModal && (
          <Modal show={remarksModal} onHide={handleRemarksModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Audit Remarks</span>
                
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">
                {" "}
                
                <div className="d-flex flex-column">
                  <Label style={{ marginTop: "2px", fontSize: "12px" }}>
                    Remarks
                  </Label>
                  <Input
                    type="textarea"
                    name="remarks"
                    value={auditingRemarksData.remarks}
                    onChange={(e) => handleChangeRemarks(e)}
                    placeholder="Enter the Remarks"
                    className="event-crowd-textarea"
                  />
                </div>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleRemarksModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleRemarksSubmit}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )} */}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "6.7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

FreelancerQc.propTypes = {
  dispatch: PropTypes.func,
  employee_list: PropTypes.array,
  recordsMetaData: PropTypes.object,
  paginationProps: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FreelancerQc)
)
